import { render, staticRenderFns } from "./AnimalHistory.vue?vue&type=template&id=23612a93&scoped=true&"
import script from "./AnimalHistory.vue?vue&type=script&lang=js&"
export * from "./AnimalHistory.vue?vue&type=script&lang=js&"
import style0 from "./AnimalHistory.vue?vue&type=style&index=0&id=23612a93&scoped=true&lang=css&"
import style1 from "./AnimalHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23612a93",
  null
  
)

export default component.exports